
import { defineComponent } from "vue";
export default defineComponent({
  name: "Side-Bar",
  emits: ["changedTheme"],
  data() {
    return {
      setMode: false,
    };
  },
  computed: {
    textButton(): string {
      if (this.setMode) {
        return "Modo Claro";
      }
      return "Modo Escuro";
    },
  },
  methods: {
    changeTheme() {
      this.setMode = !this.setMode;
      this.$emit("changedTheme", this.setMode);
    },
    reloadPage() {
      const check = window.confirm(
        "Deseja recarregar a página? Todas as suas tarefas serão perdidas"
      );
      if (check) {
        localStorage.clear();
        location.reload();
      }
    },
  },
});
